import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import withEndlessScroll from '../../HOC/endlessScroll';
import { vippedLimitQuery } from '../../../queries';
import { setError } from '../../../actions';
import Section from '../../Section';
import SectionList from '../../SectionList';
import ItemCard from '../../Cards/ItemCard';
import SectionPlaceholder from '../../Placeholders/SectionPlaceholder';
import ItemCardPlaceholder from '../../Placeholders/ItemCardPlaceholder';
import BreadcrumbsPlaceholder from '../../Placeholders/BreadcrumbsPlaceholder';

const Breadcrumbs = dynamic(() => import('../../Breadcrumbs'), {
  loading: BreadcrumbsPlaceholder,
  ssr: false
});

const vippedQueryVars = {
  limit: 24,
  offset: 0
};

let reciviesItems = vippedQueryVars.limit;

const vippedListRef = React.createRef();
const EndlessVipItems = withEndlessScroll(SectionList);

const mapDispatchToProps = dispatch => {
  return {
    setErrorUI: errorState => dispatch(setError(errorState))
  };
};

const VippedPage = ({ setErrorUI }) => {
  const [itemId, setItemId] = useState(null);
  const setCarousel = id => {
    return itemId === id ? null : setItemId(id);
  };
  const { loading, data, error, fetchMore } = useQuery(
    vippedLimitQuery(vippedQueryVars),
    {
      variables: vippedQueryVars,
      ssr: false,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first'
    }
  );

  const items = data?.items || [];
  const itemsList =
    items &&
    items.map(item => (
      <ItemCard
        key={item.id}
        carousel={true}
        itemId={itemId}
        setCarousel={setCarousel}
        {...item}
      />
    ));

  useEffect(() => {
    if (error) setErrorUI(true);
  }, [error]);

  useEffect(() => {
    return () => {
      reciviesItems = vippedQueryVars.limit;
    };
  }, []);

  return (
    <>
      <Breadcrumbs
        cypress="vipped-breadcrumbs"
        text="pages.vip.title"
        link="/"
      />
      {!(loading && !itemsList.length) ? (
        <Section
          sectionAdditionalClasses="section-block section-white"
          noHeader
        >
          <EndlessVipItems
            ref={vippedListRef}
            items={itemsList}
            loading={loading}
            listAdditionalClasses="vip-page-list"
            isStopLoad={reciviesItems < vippedQueryVars.limit}
            onLoadMore={() => {
              const currentLength = data.items.length;

              fetchMore({
                query: vippedLimitQuery({
                  limit: 24,
                  offset: currentLength
                }),
                variables: {
                  limit: 24,
                  offset: currentLength
                },
                notifyOnNetworkStatusChange: true
              }).then(fetchMoreResult => {
                reciviesItems = fetchMoreResult.data.items.length;
              });
            }}
          >
            {itemsList}
          </EndlessVipItems>
        </Section>
      ) : (
        <SectionPlaceholder noHeader={true}>
          <ItemCardPlaceholder />
          <ItemCardPlaceholder />
          <ItemCardPlaceholder />
          <ItemCardPlaceholder />
          <ItemCardPlaceholder />
          <ItemCardPlaceholder />
        </SectionPlaceholder>
      )}
    </>
  );
};

VippedPage.propTypes = {
  setPageLoader: PropTypes.func,
  setErrorUI: PropTypes.func
};

export default connect(null, mapDispatchToProps)(VippedPage);
